import React from 'react';
import {DataItem} from 'src/design-system';
import * as Yup from 'yup';
import {Text} from 'react-native';
import {Typography} from 'src/styles';
import {IDeveloperField} from 'dromo-uploader-react';
import HookFormSelectInput from 'src/hook-form-wrapper/select-input';
import {numberRange} from 'src/common-utils/nuberRange';

interface DisplayProps {
  value: string;
}

interface Props {
  name?: string;
  items?: any;
}

export const items = numberRange(1, 100).map(num => ({
  label: num.toString(),
  value: num,
}));

export const Import = (
  key: string = 'numberOfTrials',
  prefix?: string,
): IDeveloperField => ({
  label: (prefix ? prefix + ' ' : '') + 'Number of Trials',
  key,
  validators: [
    {validate: 'require_with_values', fieldValues: {method: 'trial_by_trial'}},
  ],
});

export const Value = (value: string) => {
  return value;
};

export const Display = ({value}: DisplayProps) => {
  return (
    <DataItem>
      <Text style={[Typography.H6]}>Number of Trials</Text>
      <Text style={[Typography.P3]}>{Value(value)}</Text>
    </DataItem>
  );
};

export const Input = ({name}: Props) => {
  return (
    <HookFormSelectInput
      name={(name ? name + '.' : '') + 'numberOfTrials'}
      label={'Number of Trials'}
      placeholder={'Number of Trials'}
      helper={'Total number of trials used for each target in this program'}
      required={false}
      items={items}
    />
  );
};

export const validation = () =>
  Yup.string().required('Number of Trials is required');

export default Input;
